import React, { useState } from "react";
import { CheckCircle } from "lucide-react";
import { contactPage } from "../data/siteData";

const ContactForm = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    reason: contactPage.contactReasons[0],
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim()) errs.firstName = "Required";
    if (!form.email.trim()) errs.email = "Required";
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = "Enter a valid email";
    if (!form.message.trim()) errs.message = "Required";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length === 0) {
      const submissions = JSON.parse(localStorage.getItem("p3_contact_submissions") || "[]");
      submissions.push({ ...form, submittedAt: new Date().toISOString() });
      localStorage.setItem("p3_contact_submissions", JSON.stringify(submissions));
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-10 text-center">
        <CheckCircle className="mx-auto text-p3-blue mb-4" size={48} />
        <h3 className="font-heading font-bold text-xl text-p3-navy mb-2">Message sent!</h3>
        <p className="text-sm text-p3-muted">{contactPage.successMessage}</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-8 space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-p3-navy mb-1 block">First Name *</label>
          <input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
          {errors.firstName && <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>}
        </div>
        <div>
          <label className="text-xs font-semibold text-p3-navy mb-1 block">Last Name</label>
          <input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-p3-navy mb-1 block">Phone</label>
          <input
            name="phone"
            value={form.phone}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-p3-navy mb-1 block">Email *</label>
          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
          {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
        </div>
      </div>
      <div>
        <label className="text-xs font-semibold text-p3-navy mb-1 block">Contact Reason</label>
        <select
          name="reason"
          value={form.reason}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm bg-white"
        >
          {contactPage.contactReasons.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-xs font-semibold text-p3-navy mb-1 block">Your Message *</label>
        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          rows={4}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
        />
        {errors.message && <p className="text-xs text-red-500 mt-1">{errors.message}</p>}
      </div>
      <button
        type="submit"
        className="w-full bg-p3-navy hover:bg-p3-navy-dark text-white font-semibold py-3 rounded-lg transition-colors"
      >
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
